/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComplianceAssetFindingDto } from './ComplianceAssetFindingDto';
import {
    ComplianceAssetFindingDtoFromJSON,
    ComplianceAssetFindingDtoFromJSONTyped,
    ComplianceAssetFindingDtoToJSON,
    ComplianceAssetFindingDtoToJSONTyped,
} from './ComplianceAssetFindingDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ComplianceBlastRadiusResponse
 */
export interface ComplianceBlastRadiusResponse {
    /**
     * 
     * @type {string}
     * @memberof ComplianceBlastRadiusResponse
     */
    frameworkId?: string;
    /**
     * 
     * @type {number}
     * @memberof ComplianceBlastRadiusResponse
     */
    openFindingCount?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ComplianceBlastRadiusResponse
     */
    severityBreakdown?: { [key: string]: number; };
    /**
     * 
     * @type {Array<ComplianceAssetFindingDto>}
     * @memberof ComplianceBlastRadiusResponse
     */
    assets?: Array<ComplianceAssetFindingDto>;
    /**
     * 
     * @type {number}
     * @memberof ComplianceBlastRadiusResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof ComplianceBlastRadiusResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof ComplianceBlastRadiusResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ComplianceBlastRadiusResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ComplianceBlastRadiusResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ComplianceBlastRadiusResponse interface.
 */
export function instanceOfComplianceBlastRadiusResponse(value: object): value is ComplianceBlastRadiusResponse {
    return true;
}

export function ComplianceBlastRadiusResponseFromJSON(json: any): ComplianceBlastRadiusResponse {
    return ComplianceBlastRadiusResponseFromJSONTyped(json, false);
}

export function ComplianceBlastRadiusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceBlastRadiusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'frameworkId': json['frameworkId'] == null ? undefined : json['frameworkId'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : json['severityBreakdown'],
        'assets': json['assets'] == null ? undefined : ((json['assets'] as Array<any>).map(ComplianceAssetFindingDtoFromJSON)),
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ComplianceBlastRadiusResponseToJSON(json: any): ComplianceBlastRadiusResponse {
    return ComplianceBlastRadiusResponseToJSONTyped(json, false);
}

export function ComplianceBlastRadiusResponseToJSONTyped(value?: ComplianceBlastRadiusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frameworkId': value['frameworkId'],
        'openFindingCount': value['openFindingCount'],
        'severityBreakdown': value['severityBreakdown'],
        'assets': value['assets'] == null ? undefined : ((value['assets'] as Array<any>).map(ComplianceAssetFindingDtoToJSON)),
        'queryDurationMs': value['queryDurationMs'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

